// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import xnetEntity from './entities/xnet.json';
import xnetMenu from '../pages/xnet/menu.json';
import xnetFullForm from '../pages/xnet/forms/full.json';
import xnetContextForm from '../pages/xnet/forms/context.json';
import xnetMiniForm from '../pages/xnet/forms/mini.json';
import xnetLookupForm from '../pages/xnet/forms/lookup.json';
import xnetTableView from '../pages/xnet/views/table.json';
import xnetStagesView from '../pages/xnet/views/stages.json';
import xnetCardsView from '../pages/xnet/views/cards.json';
import xnetInlineView from '../pages/xnet/views/inline.json';
import xnetBacklogView from '../pages/xnet/views/backlog.json';
import xnetSplitView from '../pages/xnet/views/split.json';
import xnetCalendarView from '../pages/xnet/views/calendar.json';
import xnetDashboardView from '../pages/xnet/views/dashboard.json';

/** Тип запису «Експерт» зі сторінками пакета: меню, форми та подання з pages/xnet/. */
export const xnetDefinition: IRecordTypeDefinition = {
  ...xnetEntity,
  views: assembleViewSet({
      table: xnetTableView,
      stages: xnetStagesView,
      cards: xnetCardsView,
      inline: xnetInlineView,
      backlog: xnetBacklogView,
      split: xnetSplitView,
      calendar: xnetCalendarView,
      dashboard: xnetDashboardView,
  }),
  form: xnetFullForm,
  forms: { full: xnetFullForm, context: xnetContextForm, mini: xnetMiniForm, lookup: xnetLookupForm },
  menu: xnetMenu,
} as IRecordTypeDefinition;
